
 // form field help popovers
    $("input[data-content],select[data-content],div.form-control[data-content]").popover({
        container: "body",
        trigger: "manual",
        placement: function (popover,element) {
            if ($(element).hasClass("popover-placement-bottom")) {
                return "bottom";
            }
            return "auto top";
        },
        html: true
    }).on("shown.bs.popover", function () {
        $(this).data("popover-visible", true);
    }).on("hidden.bs.popover", function () {
        $(this).data("popover-visible", false);
    });

    // show / hide the form field help popovers
    $(".input-group button[type=button]").on("click", function () {
        var input = $(this).parents("div.input-group").children("input,select,div.form-control");
        if (input.data("popover-visible")) {
            input.popover("hide");
        }
        else {
            input.popover("show");
        }

        input.one("blur", function () {
            if (input.data("popover-visible")) {
                input.popover("hide");
            }

        });
        input.focus();
    });


if (!Modernizr.inputtypes.date && $.fn.datepicker) {
        $('input[type=date]:not([readonly])').datepicker({
            autoclose: true,
            format: "yyyy-mm-dd"
        });
    }
